self["MonacoEnvironment"] = (function (paths) {
      function stripTrailingSlash(str) {
        return str.replace(/\/$/, '');
      }
      return {
        globalAPI: false,
        getWorkerUrl: function (moduleId, label) {
          var pathPrefix = typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : "/web/";
          var result = (pathPrefix ? stripTrailingSlash(pathPrefix) + '/' : '') + paths[label];
          if (/^((http:)|(https:)|(file:)|(\/\/))/.test(result)) {
            var currentUrl = String(window.location);
            var currentOrigin = currentUrl.substr(0, currentUrl.length - window.location.hash.length - window.location.search.length - window.location.pathname.length);
            if (result.substring(0, currentOrigin.length) !== currentOrigin) {
              if(/^(\/\/)/.test(result)) {
                result = window.location.protocol + result
              }
              var js = '/*' + label + '*/importScripts("' + result + '");';
              var blob = new Blob([js], { type: 'application/javascript' });
              return URL.createObjectURL(blob);
            }
          }
          return result;
        }
      };
    })({
  "editorWorkerService": "editor.worker.js",
  "css": "css.worker.js",
  "html": "html.worker.js",
  "json": "json.worker.js",
  "typescript": "ts.worker.js",
  "javascript": "ts.worker.js",
  "less": "css.worker.js",
  "scss": "css.worker.js",
  "handlebars": "html.worker.js",
  "razor": "html.worker.js"
});
require("./contrib/bracketMatching/browser/bracketMatching.js");
require("./browser/coreCommands.js");
require("./contrib/colorPicker/browser/colorContributions.js");
require("./contrib/comment/browser/comment.js");
require("./contrib/documentSymbols/browser/documentSymbols.js");
require("./contrib/folding/browser/folding.js");
require("./contrib/format/browser/formatActions.js");
require("./contrib/inlayHints/browser/inlayHintsContribution.js");
require("./contrib/inlineCompletions/browser/inlineCompletionsContribution.js");
require("./contrib/lineSelection/browser/lineSelection.js");
require("./contrib/linesOperations/browser/linesOperations.js");
require("./contrib/linkedEditing/browser/linkedEditing.js");
require("./contrib/parameterHints/browser/parameterHints.js");
require("./contrib/rename/browser/rename.js");
require("./contrib/snippet/browser/snippetController2.js");
require("./contrib/suggest/browser/suggestController.js");
require("./contrib/tokenization/browser/tokenization.js");
require("./contrib/unicodeHighlighter/browser/unicodeHighlighter.js");
require("./contrib/wordHighlighter/browser/wordHighlighter.js");
require("./contrib/wordOperations/browser/wordOperations.js");
require("./contrib/wordPartOperations/browser/wordPartOperations.js");
module.exports = require("!!./editor.main.js");
require("../basic-languages/cpp/cpp.contribution.js");
require("../basic-languages/csharp/csharp.contribution.js");
require("../basic-languages/css/css.contribution.js");
require("../language/css/monaco.contribution.js");
require("../basic-languages/html/html.contribution.js");
require("../language/html/monaco.contribution.js");
require("../basic-languages/java/java.contribution.js");
require("../basic-languages/javascript/javascript.contribution.js");
require("../language/json/monaco.contribution.js");
require("../basic-languages/kotlin/kotlin.contribution.js");
require("../basic-languages/php/php.contribution.js");
require("../basic-languages/python/python.contribution.js");
require("../basic-languages/ruby/ruby.contribution.js");
require("../basic-languages/sql/sql.contribution.js");
require("../basic-languages/swift/swift.contribution.js");
require("../basic-languages/typescript/typescript.contribution.js");
require("../language/typescript/monaco.contribution.js");
require("../basic-languages/go/go.contribution.js");
require("../basic-languages/r/r.contribution.js");